export default __webpack_public_path__ + "static/media/Logo.105822bd.PNG";